import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../../_metronic/layout";
import { ObjectEdit } from '../../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './AuditQuestionUtils';
import { FilterObjectsUIProvider } from '../../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';

const AuditQuestionPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.auditQuestions }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/auditQuestions")) {
    const temp = menuList.find(q => q.url == "/auditQuestions")
    isFullAccess = temp.isFullAccess;
  }

  const otherTabs = [
    { id: 2, title: "تکمیل پرسشنامه", tab: 'questionlist', component: AuditQuestionPage },
    // { id: 3, title: "MODULES.BASEINFO.ROLE.PERMISSION_SELF", tab: 'selfAccess'},
    // { id: 4, title: "MODULES.BASEINFO.ROLE.PERMISSION_SELF_TYPE", tab: 'selfTypeAccess'},
  ];


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          <ContentRoute path="/auditQuestions/new"
            render={props =>
              <ObjectEdit
                {...props}
                auditEdit={true}
                isFullAccess={isFullAccess}
                basePath="/auditQuestions"
                api="api/FormQuestion"
                currentState={currentState}
                initObject={initObject}
                formFields={formFields}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                otherTabs={otherTabs}
                prepareFilter={prepareFilter}
              />}
          />

          <ContentRoute
            path="/auditQuestions/:id/edit"
            render={props =>
              <ObjectEdit
                {...props}
                auditEdit={true}
                isFullAccess={isFullAccess}
                basePath="/auditQuestions"
                api="api/FormQuestion"
                currentState={currentState}
                initObject={initObject}
                formFields={formFields}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                otherTabs={otherTabs}
                prepareFilter={prepareFilter}
              />}
          />

          <ContentRoute
            path="/auditQuestions"
            render={props => <ObjectsPage
              AuditAction={true}
              haveGeneralAction={false}
              isFullAccess={isFullAccess}
              basePath="/auditQuestions"
              api="api/FormQuestion"
              currentState={currentState}
              columns={columns}
              prepareFilter={prepareFilter}
              filterFields={filterFields}
              filterInitialValues={filterInitialValues}
            />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default AuditQuestionPage



